import { Button, Col, Form, Input, InputNumber, message, Row, Spin, Typography } from "antd";
import { useEffect, useState } from "react";

import { LoadingOutlined } from "@ant-design/icons";
import { getConstants, postConstants, updateConstants } from "api/constants";

type Constant = {
  id: string | undefined;
  fillingFactor: number | undefined;
  repititionRate: number | undefined;
  efficiency: number | undefined;
  maxPhotons: number | undefined;
  maxModes: number | undefined;
  freeCredits: number | undefined;
};

const constants = [
    // {
    //     label: "Demultiplexing factor (FF)",
    //     name: "fillingFactor",
    // },
    // {
    //     label: "Laser Repetition Rate (f rep)",
    //     name: "repititionRate",
    // },
    // {
    //     label: "Efficiency (η)",
    //     name: "efficiency",
    // },
    {
        label: "Maximum number of photons",
        name: "maxPhotons",
    },
    {
        label: "Maximum number of modes",
        name: "maxModes",
    },
    {
        label: "Free credits",
        name: "freeCredits",
    },
];

export const AdminConfigureConstants = () => {
  const [values, setValues] = useState(() =>
    constants.reduce((acc, curr) => {
      acc[curr.name as keyof Constant] = undefined;
      return acc;
    }, {} as Constant)
  );
  const [loading, setLoading] = useState(false);
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { data } = await getConstants();
      setLoading(false);
      setValues({
        id: data[0].id,
        fillingFactor: Number(data[0].fillingFactor),
        repititionRate: Number(data[0].repititionRate),
        efficiency: Number(data[0].efficiency),
        maxPhotons: Number(data[0].maxPhotons),
        maxModes: Number(data[0].maxModes),
        freeCredits: Number(data[0].freeCredits)
      });
    })();
  }, []);

  return (
    <Spin
      spinning={loading && !changed}
      indicator={<LoadingOutlined style={{ fontSize: 48, color: "white" }} spin />}>
      <Row>
        <Col span={10}>
          <Typography.Title
            style={{
              fontSize: "16px",
              fontWeight: 600,
              lineHeight: "23.2px"
            }}>
            Configure constants
          </Typography.Title>
          <Typography style={{ fontSize: "14px", fontWeight: 400, color: "#B5B5B5" }}>
            Constants used across the application
          </Typography>
        </Col>
        <Col span={14}>
          <Spin spinning={loading}>
            <Form layout="vertical">
              {constants.map((constant) => (
                <Form.Item 
                  label={constant.label}
                  key={constant.label}
                >
                  <InputNumber
                    style={{ 
                      height: "44px", 
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                  }}
                    value={values[constant.name as keyof Constant]}
                    defaultValue={values[constant.name as keyof Constant]}
                    name={constant.name}
                    controls={false}
                    precision={0}
                    min={0}
                    onChange={(value) => {
                      setValues({
                        ...values,
                        [constant.name]: Number(value)
                      });
                      if (!changed) setChanged(true);
                    }}
                  />
                </Form.Item>
              ))}

              <Button
                style={{
                  height: "44px",
                  width: "100%",
                  borderRadius: "8px",
                  border: "none",
                  fontFamily: "Titillium web",
                  fontSize: "16px",
                  fontWeight: "600",
                  lineHeight: "24px"
                }}
                loading={loading}
                disabled={!changed}
                onClick={async () => {
                  setLoading(true);
                  // check if all values are positive numbers and not alphabets or symbols or negative numbers or falsy values
                  for (const key in values) {
                    if (key !== "id") {
                      if (
                        !values[key as keyof Constant] ||
                        Number(values[key as keyof Constant]) < 0 ||
                        isNaN(Number(values[key as keyof Constant]))
                      ) {
                        message.error(
                          "Please enter valid values for all the constants. All values should be positive numbers."
                        );
                        return;
                      }
                    }
                  }
                  if (values.id) {
                    await updateConstants(values.id, values);
                    message.success("Constants updated successfully!");
                  } else {
                    await postConstants(values);
                    message.success("Constants created successfully!");
                  }
                  setChanged(false);
                  setLoading(false);
                }}>
                Save
              </Button>
            </Form>
          </Spin>
        </Col>
      </Row>
    </Spin>
  );
};
